module.exports = __webpack_public_path__ + "static/media/helicopter.2fe1e760.svg";